import {Alert, Button, Spinner} from 'react-bootstrap';
import {FaCommentDots, FaPlus} from 'react-icons/fa';
import {chatErrorMessage, conversationDisplayName} from '../chatUtils';
import {MessageComposer, MessageItem} from '../MessageComponents';
import ChatHeader from './ChatHeader';

function EmptyConversation({onCreate}) {
    return (
        <div className="chat-empty-state">
            <FaCommentDots />
            <h2>Start chatting with your Admin team</h2>
            <p>Create a channel, direct message, or group conversation.</p>
            {onCreate ? <Button onClick={onCreate}><FaPlus className="me-2" />New conversation</Button> : null}
        </div>
    );
}

export default function ConversationPane({
    conversation,
    currentUser,
    connectionStatus,
    showSidebar,
    onOpenSidebar,
    onCreate,
    onOpenThread,
    timeline,
    globalError,
    renderHeaderActions,
    renderMessageActions,
}) {
    const error = timeline.error || globalError;
    return (
        <main className="chat-main">
            <ChatHeader
                conversation={conversation}
                currentUserId={currentUser?.id}
                connectionStatus={connectionStatus}
                showSidebar={showSidebar}
                onOpenSidebar={onOpenSidebar}
                renderActions={renderHeaderActions}
            />
            {error ? <Alert variant="danger" className="m-2">{chatErrorMessage(error)}</Alert> : null}
            {!conversation ? <EmptyConversation onCreate={onCreate} /> : (
                <>
                    <div className="chat-timeline" ref={timeline.timelineRef} onScroll={timeline.handleScroll}>
                        {timeline.hasMore ? <Button size="sm" variant="link" onClick={timeline.loadOlder}>Load older messages</Button> : null}
                        {timeline.loading ? <div className="chat-loading"><Spinner /></div> : null}
                        {!timeline.loading && timeline.messages.length === 0 ? (
                            <div className="chat-conversation-start">This is the beginning of the conversation.</div>
                        ) : null}
                        {timeline.messages.map(message => (
                            <MessageItem
                                key={message.id}
                                message={message}
                                conversation={conversation}
                                currentUser={currentUser}
                                onReply={onOpenThread}
                                onEdit={timeline.actions.edit}
                                onDelete={timeline.actions.remove}
                                onReaction={timeline.actions.react}
                                onRetry={timeline.actions.retry}
                                renderActions={renderMessageActions}
                            />
                        ))}
                    </div>
                    {timeline.newMessageNotice ? (
                        <button type="button" className="chat-new-message" onClick={timeline.scrollToBottom}>New messages ↓</button>
                    ) : null}
                    <MessageComposer
                        conversation={conversation}
                        onSend={timeline.sendMessage}
                        placeholder={`Message ${conversationDisplayName(conversation, currentUser?.id)}`}
                    />
                </>
            )}
        </main>
    );
}
